const buildUrl = (pathname: string, searchParams: URLSearchParams) => {
  const search = searchParams.toString();
  return `${pathname}${search ? `?${search}` : ""}`;
};

export { buildUrl };
